"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * @file: 拉取数据 hooks
 * @author: yangqianjun
 * @Date: 2019-12-16 18:33:46
 * @LastEditors: yangqianjun
 * @LastEditTime: 2020-01-03 16:16:40
 */
var react_1 = require("react");
var consts_1 = require("./consts");
/** 状态 */
var FetchType;
(function (FetchType) {
    FetchType["fetching"] = "fetching";
    /** cancel */
    FetchType["cancel"] = "cancel";
    /** 出错 */
    FetchType["error"] = "error";
    /** 成功 */
    FetchType["result"] = "result";
})(FetchType = exports.FetchType || (exports.FetchType = {}));
function fetchReducer(state, action) {
    var type = action.type, _a = action.result, result = _a === void 0 ? null : _a, res = action.res;
    switch (type) {
        // 不清空数据
        case FetchType.error:
            return tslib_1.__assign(tslib_1.__assign({}, state), { fetching: false, res: res, error: result });
        case FetchType.result:
            return tslib_1.__assign(tslib_1.__assign({}, state), { error: null, fetching: false, res: res,
                result: result });
        // 不清空数据和错误
        case FetchType.fetching:
            return state.fetching
                ? state
                : tslib_1.__assign(tslib_1.__assign({}, state), { fetching: true });
        case FetchType.cancel:
            return state.fetching
                ? tslib_1.__assign(tslib_1.__assign({}, state), { fetching: false }) : state;
        default:
            return state;
    }
}
exports.fetchReducer = fetchReducer;
exports.DefaultFetchState = {
    fetching: false,
    result: null,
    res: null,
    error: null
};
function useFetch(conf) {
    var fetch = conf.fetch, paramsArr = conf.paramsArr, _a = conf.lazy, lazy = _a === void 0 ? false : _a;
    var cancelLastFetch = react_1.useRef();
    var _b = react_1.useReducer(fetchReducer, exports.DefaultFetchState), _c = _b[0], result = _c.result, fetching = _c.fetching, error = _c.error, res = _c.res, dispath = _b[1];
    // IMP: 避免发起重复请求
    var doFetch = react_1.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // start
        dispath({ type: FetchType.fetching });
        // auto cancel
        cancelLastFetch.current && cancelLastFetch.current(consts_1.AjaxCancelMessage);
        // eslint-disable-next-line prefer-spread
        var prom = fetch.apply(null, args);
        var cancel = prom['cancel'];
        if (cancel) {
            cancelLastFetch.current = cancel;
        }
        return prom
            .then(function (res) { return res; }, function (e) { return ({
            code: consts_1.AjaxErrorCode,
            message: (e && e.message) || e.toString(),
            result: null
        }); })
            .then(function (res) {
            var message = res.message, code = res.code, result = res.result;
            // IMP: only itself
            if (cancelLastFetch.current === cancel) {
                cancelLastFetch.current = undefined;
            }
            var update = function () {
                if (code !== 0) {
                    dispath({ type: FetchType.error, result: message, res: res });
                }
                else {
                    dispath({ type: FetchType.result, result: result, res: res });
                }
            };
            // IMP: for react test
            if (process.env.NODE_ENV === 'test') {
                require('react-dom/test-utils').act(function () {
                    update();
                });
            }
            else {
                update();
            }
            return res;
        });
    }, [fetch]);
    var paramsArrString = JSON.stringify(paramsArr);
    // do fetch
    react_1.useEffect(function () {
        if (lazy !== true) {
            // eslint-disable-next-line prefer-spread
            doFetch.apply(null, JSON.parse(paramsArrString));
        }
    }, [doFetch, lazy, paramsArrString]);
    return {
        result: result,
        fetching: fetching,
        error: error,
        doFetch: doFetch,
        res: res
    };
}
exports.useFetch = useFetch;
//# sourceMappingURL=useFetch.js.map